export interface StatisticCampaign {
  campaignId: number,
  totalSent: number,
  totalOpened: number,
  openedPercentage: number,
  lastOpenedAt: string,
  totalBuys?: number,
  totalIncome?: number,
  delivered?: number;
  processed?: number;
  opens?: number;
  clicks?: number;
  uniqueClicks?: number;
  bounces?: number;
  unsubscribes?: number;
}

export interface FullCampaignStatistic {
  campaignId: number;
  wineryId: string; 
  campaignName: string;
  scheduledDate: string;
  totalIncome: number;
  totalUniqueBuyers: number;
  blocks: number;
  bounceDrops: number;
  bounces: number;
  clicks: number;
  deferred: number;
  delivered: number;
  invalidEmails: number;
  opens: number;
  processed: number;
  requests: number;
  spamReportDrops: number;
  spamReports: number;
  uniqueClicks: number;
  uniqueOpens: number;
  unsubscribeDrops: number;
  unsubscribes: number;
  date: string;
}

export enum DownloadType {
  ALL = 'ALL',
  NOT_DELIVERED = 'NOT_DELIVERED',
  OPENED = 'OPENED',
  NOT_OPENED = 'NOT_OPENED'
}

export interface SendGridMessageDTO {
  from_email: string;
  msg_id: string;
  subject: string;
  to_email: string;
  status: string;
  opens_count: number;
  clicks_count: number;
  last_event_time: string;
  name?: string;
}

export interface SendGridMessagesPage {
  messages: SendGridMessageDTO[];
  nextCursor?: string | null;
  reason?: string | null;
}